import React, { useEffect, useState } from 'react';
import loadable from '@loadable/component';
import { serializeNodesToHtml } from '@plone/volto-slate/editor/render';
import { useDispatch, useSelector } from 'react-redux';
import { searchContent } from '@plone/volto/actions';
import { Icon } from '@plone/volto/components';

// Carica Leaflet solo lato client
const MapComponent = loadable(() => import('./MapComponent'), { 
  ssr: false,
  fallback: <div>Loading map...</div>
});

const View = (props) => {
  const { content } = props;
  const [locations, setLocations] = useState([]);
  const dispatch = useDispatch();

  // Stato della ricerca
  const searchResults = useSelector((state) => state.search.subrequests.luoghi || {});
  const { items: subitems = [], loading, error } = searchResults;

  // Effettua la ricerca
  useEffect(() => {
    dispatch(
      searchContent(
        '/', // Cerca in tutto il sito
        {
          portal_type: ['Luogo'],
          fullobjects: 1,
          b_size: 1000,
          sort_on: 'created',
          sort_order: 'descending'
        },
        'luoghi' // Nome univoco per la subrequest
      )
    );
  }, [dispatch]);

  // Mappa i dati per la mappa
  useEffect(() => {
    const newLocations = subitems
      .filter((item) => item['@type'] === 'Luogo')
      .map((item) => {
        const lat = parseFloat(item.latitudine);
        const lng = parseFloat(item.longitudine);
        const hasValidCoords = !isNaN(lat) && !isNaN(lng);
        
        return {
          id: item['@id'],
          title: item.title,
          coordinates: hasValidCoords ? [lat, lng] : null,
          address: [item.indirizzo, item.cap].filter(Boolean).join(', '),
          description: item.testodescrittivo,
          isValid: hasValidCoords
        };
      })
      .filter(loc => loc.isValid); // Filtra solo quelli con coordinate valide

    setLocations(newLocations);
  }, [subitems]);

  if (loading) {
    return (
      <div className="loading-container">
        <Icon name="spinner" size="30px" spin />
        <p>Caricamento luoghi in corso...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-message">
        <Icon name="warning" size="30px" />
        <p>Errore nel caricamento dei luoghi: {error.message}</p>
      </div>
    );
  }

  return (
    <div className="block-lista-luoghi">
      <h2 className="block-title">Lista Luoghi</h2>
      
      <div className="map-wrapper">
        {locations.length > 0 ? (
          <MapComponent locations={locations} />
        ) : (
          <p className="no-results">Nessun luogo trovato con coordinate valide.</p>
        )}
      </div>

      {/*
      <div className="locations-list">
        {subitems
          .filter((item) => item['@type'] === 'Luogo')
          .map((item) => {
            let descriptionHTML = '';
            if (item.testodescrittivo) {
              if (typeof item.testodescrittivo === 'string') {
                descriptionHTML = item.testodescrittivo;
              } else if (item.testodescrittivo.data) {
                descriptionHTML = item.testodescrittivo.data;
              } else if (item.testodescrittivo.value) {
                descriptionHTML = serializeNodesToHtml(item.testodescrittivo.value);
              }
            }

            return (
              <div key={item['@id']} className="location-item">
                <h3 className="location-title">{item.title}</h3>
                {item.indirizzo && (
                  <p className="location-address">
                    <Icon name="marker" size="16px" /> {item.indirizzo}
                    {item.cap && `, ${item.cap}`}
                  </p>
                )}
                {descriptionHTML && (
                  <div 
                    className="location-description" 
                    dangerouslySetInnerHTML={{ __html: descriptionHTML }} 
                  />
                )}
                {item.latitudine && item.longitudine && (
                  <p className="location-coords">
                    Coordinate: {parseFloat(item.latitudine).toFixed(6)}, {parseFloat(item.longitudine).toFixed(6)}
                  </p>
                )}
              </div>
            );
          })}
      </div>
      */}
    </div>
  );
};

export default View;